export { default } from './Benefit';
